import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';

import { LoadingSpinner } from '../LoadingSpinner';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Check if user is authenticated after OAuth redirect
        const user = await getCurrentUser();
        if (user) {
          // Redirect to dashboard or intended page
          const redirectTo = searchParams.get('redirect') || '/';
          navigate(redirectTo, { replace: true });
        } else {
          // Authentication failed, redirect to sign in
          navigate('/signin', { replace: true });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/signin', { replace: true });
      }
    };

    handleAuthCallback();
  }, [navigate, searchParams]);

  return (
    <LoadingSpinner
      title="Completing Authentication"
      message="Processing your sign-in..."
    />
  );
};

export default AuthCallback;
